export default __webpack_public_path__ + "static/media/people2.39feec59.png";